module.exports = __webpack_public_path__ + "media/images/emblems/Leuzigen-coat_of_arms-20310cbeaa3107171c9e30059a920382.svg";